import React from "react";
import MainToolbar from "../MainToolbar";
import moment from "moment";

import { makeStyles } from "@material-ui/core";
import EditCollectionView from "../EditCollectionView";
import { useSelector } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import {
  formatPosition,
  formatDistance,
  formatDate,
  formatSpeed,
} from "../common/formatter";
import { useAttributePreference } from "../common/preferences";

const columns = [
  { field: "deviceName", headerName: "Device", width: 150 },
  {
      field: "latitude",
      headerName: "Latitude",
      width: 155,
    },
    {
      field: "longitude",
      headerName: "Longitude",
      width: 168,
    },
  {
    field: "address",
    headerName: "Address",
    width: 155,
  },
  {
    field: "fixTime",
    headerName: "Fix Time",
    width: 155,
  },
  {
    field: "serverTime",
    headerName: "Server Time",
    width: 185,
  },
  {
    field: "speed",
    headerName: "Speed",
    width: 140,
  },
  {
    field: "ignition",
    headerName: "Ignition",
    width: 147,
  },
  {
      field: "ac",
      headerName: "AC",
      width: 110,
    },
    {
        field: "blocked",
        headerName: "blocked",
        width: 150,
      },
 {
        field: "lastCan",
        headerName: "CAN Captured Time",
        width: 150,
      },
  {
    field: "soc",
    headerName: "SOC",
    width: 130,
  },
  {
    field: "bcm",
    headerName: "BCM",
    width: 130,
  },
  {
    field: "dte",
    headerName: "DTE",
    width: 130,
  },
  {
    field: "hours",
    headerName: "Hours",
    width: 140,
  },
  {
    field: "todayDistance",
    headerName: "Today Distance",
    width: 160,
  },
  {
    field: "totalDistance",
    headerName: "Total Distance",
    width: 150,
  },
  {
    field: "fuel",
    headerName: "Fuel",
    width: 150,
  },
  {
    field: "temperature",
    headerName: "Temperature",
    width: 165,
  },
  {
    field: "todayMaxSpeed",
    headerName: "Today Max Speed",
    width: 150,
  },
];
const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: "white",
  },
  rowAction: {
    backgroundColor: "#361DDB",
  },
  iconButtons: {
    display: "flex",
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: "#EFEFEF",
    margin: "2px",
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
}));

const CanDataView = () => {
  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const positions = useSelector((state) =>
    Object.values(state.positions.items)
  );
  const deviceData = useSelector((state) => state.devices.items);

  try {
    const rows = positions.map((item) => {
      const deviceName = deviceData[item.deviceId]?.name;
      return {
        ...item,
        ...item.attributes,
        deviceName,
        latitude: formatPosition(item, "latitude"),
        longitude: formatPosition(item, "longitude"),
        address: formatPosition(item, "address"),
        fixTime: formatDate(item.fixTime, "MMM D, hh:mm A"),
        serverTime: formatDate(item.serverTime, "LLL"),
        speed: formatSpeed(item.speed, speedUnit),
        lastCan: formatDate(item.lastCan, "MMM D, hh:mm A"),
        totalDistance: formatDistance(
          item.attributes.totalDistance,
          distanceUnit
        ),
        todayDistance: formatDistance(
          item.attributes.todayDistance,
          distanceUnit
        ),
       dte: formatDistance(
          item.attributes.dte,
          distanceUnit
        ),
        hours: formatDate(
          moment().add(-item.attributes.hours, "milliseconds"),
          "hh[h]:mm[m]"
        ),
        todayMaxSpeed: formatSpeed(item.attributes.todayMaxSpeed, speedUnit),
      };
    });

    return (
      <div style={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={100}
          disableSelectionOnClick
        />
      </div>
    );
  } catch (error) {
    console.log(error); // You might send an exception to your error tracker like AppSignal
  }
};

const CanDataPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={CanDataView}
        editPath="/reports/candata"
        endpoint="candata"
        successDialogShow={false}
      />
    </>
  );
};

export default CanDataPage;
